<script lang="ts" setup>
import { AudioPlayInstance } from "@/components/mobile/AudioPlay.vue";
import ChatMsgUnlock from "@/components/mobile/chat/common/ChatMsgUnlock.vue";
import ChatMessageItem from "@/components/mobile/ChatMessageItem.vue";
import UserAvatar from "@/components/UserAvatar.vue";
import { useMarkdownHTML } from "@/composable/text/useMarkdown";
import { ChatMessageImageType, DEFAULT_COST } from "@/enums/chatEnums";
import { IChatMessageItem } from "@/types/chat";
import { ChatMessageItemInstance } from "@/types/component";
import { useRawImageUrl } from "@/use/common";
import { useElementVisibility } from "@vueuse/core";
import { showImagePreview } from "vant";
import { ref, watch } from "vue";

const props = withDefaults(
  defineProps<
    IChatMessageItem & {
      avatarList?: string[];
      item?: ChatMessage;
      enableAvatar: boolean;
    }
  >(),
  {
    enableAvatar: true,
    mateUuid: "",
    avatarUrl: "",
    msg: "",
    enableAvatarClick: false,
    isLocked: false,
    requireUnlock: 0,
    unlockCost: DEFAULT_COST,
    avatarList: () => [],
  }
);

watch(
  () => props.enableAvatar,
  (newVal, oldVal) => {
    console.log("enableAvatar", newVal);
  }
);

const bubbleRef = ref<HTMLElement | null>(null);
const audioRef = ref<AudioPlayInstance | null>(null);
const translateResult = ref<string>("");
const { html: contentHtml } = useMarkdownHTML(() => props.msg, {
  escapeHTML: false,
  transformBeforeLastBreak: props.enableParseMd,
});
const { html: translateHtml } = useMarkdownHTML(translateResult, {
  escapeHTML: false,
});

defineExpose<ChatMessageItemInstance>({
  id: props.id,
  onAvatarClick: () => {},
  audioRef,
});

const clickImageMessage = () => {
  showImagePreview([useRawImageUrl(props.media!.url!)]);
};

const container = ref<HTMLElement | null>(null);
const isVisible = useElementVisibility(container);
</script>
<template>
  <div ref="container" class="flex gap-1 border-b /80 py-2">
    <div class="w-[30px]" v-if="item?.type !== 'Narration' && enableAvatar">
      <van-sticky v-if="isVisible" :offset-top="65">
        <div
          v-if="avatarList.length > 0"
          class="w-[30px] flex flex-col gap-1 shrink-0"
        >
          <user-avatar
            v-for="avatarUrl in avatarList"
            :key="avatarUrl"
            :avatar-url="avatarUrl"
            class="chat-image h-10 self-start shrink-0"
          />
        </div>
        <user-avatar
          v-else
          :avatar-url="avatarUrl"
          class="chat-image h-10 self-start shrink-0"
        />
      </van-sticky>
      <template v-else>
        <div
          v-if="avatarList.length > 0"
          class="w-[30px] flex flex-col gap-1 shrink-0"
        >
          <user-avatar
            v-for="avatarUrl in avatarList"
            :key="avatarUrl"
            :avatar-url="avatarUrl"
            class="chat-image h-10 self-start shrink-0"
          />
        </div>
        <user-avatar
          v-else
          :avatar-url="avatarUrl"
          class="chat-image h-10 self-start shrink-0"
        />
      </template>
    </div>
    <div ref="bubbleRef" class="flex px-2 max-w-full">
      <div class="flex flex-col">
        <slot>
          <div class="flex flex-col gap-2">
            <div
              :class="[
                item?.type === 'Narration'
                  ? 'text-base-content/50 text-xs'
                  : 'chat-container',
              ]"
              v-html="
                contentHtml || media
                  ? contentHtml
                  : `[${$t('Message.newsSeemsMissing')}]`
              "
            />
            <div v-if="media" class="w-[10rem]" @click="clickImageMessage">
              <ImageCard
                :is-nsfw="media.isNsfw"
                :media="media"
                crossorigin="anonymous"
              />
            </div>
          </div>
          <div
            v-if="translateHtml"
            class="chat-container"
            v-html="translateHtml"
          />
          <ChatMsgUnlock
            v-if="isLocked"
            :msgId="id!"
            :unlock-cost="unlockCost"
          />
        </slot>
      </div>
    </div>
  </div>
</template>
